import { ResourcePool } from "./castle";

export const UnitClass = {
  Infantry: 0,
  Ranger: 1,
  Mage: 2,
  Signature: 3,
} as const;

// Legacy emoji fallback used in a few text-only places (event lines, etc).
// For full icon rendering use UnitClassIcons from components/icons.tsx.
export const UnitClassIcon: Record<number, string> = {
  0: "🛡️",
  1: "🏹",
  2: "🧙",
  3: "🔥",
};

export const UnitClassRu: Record<number, string> = {
  0: "Пехота",
  1: "Стрелки",
  2: "Маги",
  3: "Особые",
};

export const ElementRu: Record<number, string> = {
  0: "Огонь",
  1: "Вода",
  2: "Воздух",
  3: "Земля",
};

export interface UnitCatalogEntry {
  id: string;
  name: string;
  element: number;
  elementName: string;
  cls: number;
  className: string;
  hp: number;
  attack: number;
  defense: number;
  costPerUnit: ResourcePool;
  timePerUnitSeconds: number;
  trainable: boolean;
}
